import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { ErrorHandler, LOCALE_ID, NgModule, Provider } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { StoreRouterConnectingModule } from '@ngrx/router-store'
import * as Sentry from '@sentry/angular-ivy'
import { Angulartics2Module } from 'angulartics2'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { appConfig } from '../brands/_current/config/app-config'
import { environment } from '../environments/environment'
import { EnvironmentName } from '../environments/environment.enum'
import { AccountModule } from './account/account.module'
import { UnauthorizedInterceptor } from './account/shared/unauthorized.interceptor'
import { AppRoutingModule } from './app-routing.module'
import { AppStoreModule } from './app-store.module'
import { AppComponent } from './app.component'
import { FeedbackModule } from './feedback/feedback.module'
import { PendingOperationInterceptor } from './pending-operation/shared/pending-operation.interceptor'
import { CommonHeadersModule } from './shared/common-headers/common-headers.module'
import { MyCiceroWebApiModule } from './shared/mycicero-web-api/my-cicero-web-api.module'
import { HttpReplayInterceptor } from './shared/replay-interceptor/http-replay.interceptor'

const defaultLocale = 'it-IT'
const devProviders: Provider[] =
  environment.name === EnvironmentName.Dev ? [{ provide: LOCALE_ID, useValue: defaultLocale }] : []
const prodProviders: Provider[] = appConfig.core.monitoring.enabled
  ? [
      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler({
          logErrors: true,
        }),
      },
    ]
  : []

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AccountModule,
    FeedbackModule,
    AppStoreModule,
    HttpClientModule,
    CommonHeadersModule,
    MyCiceroWebApiModule,
    StoreRouterConnectingModule.forRoot(),
    ProgressSpinnerModule,
    Angulartics2Module.forRoot({
      // developerMode: environment.name !== EnvironmentName.Prod,
      gst: {
        trackingIds: appConfig.analytics.googleGlobalSiteTag.trackers.map((tracker) => tracker.id),
        anonymizeIp: appConfig.analytics.googleGlobalSiteTag.anonymizeData,
      },
    }),
    AppRoutingModule,
  ],
  providers: [
    ...devProviders,
    ...prodProviders,
    { provide: HTTP_INTERCEPTORS, useClass: HttpReplayInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: PendingOperationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
